module.exports = __webpack_public_path__ + "img/464ff22.png";